<template>
    <section style="overflow-x: auto; width: 100%; scrollbar-width: none">
        <table style="width: 100%;" v-bind:class="{ 'tx-msg-table--mobile': isMobile }">
            <tr>
                <td>Source</td>
                <td>
                    <ui-address v-if="source" hide-name v-bind:address="source"/>
                    <template v-else>empty</template>
                </td>
            </tr>
            <tr>
                <td>Destination</td>
                <td>
                    <ui-address v-if="destination" hide-name v-bind:address="destination"/>
                    <template v-else>empty</template>
                </td>
            </tr>
            <tr>
                <td>Value</td>
                <td>{{$ton(value, false)}} GRAM</td>
            </tr>
            <tr>
                <td>Forward fee</td>
                <td>{{$fee(fwdFee)}} GRAM</td>
            </tr>
            <tr>
                <td>IHR fee</td>
                <td>{{$fee(ihrFee)}} GRAM</td>
            </tr>
            <tr>
                <td>Creation LT</td>
                <td v-text="createdLt || 0"/>
            </tr>
            <tr>
                <td>Hash</td>
                <td>
                    <ui-copy-button class="tx-msg-hash" v-bind:copy="hash">
                        <span v-if="isMobile" class="ui-looong"
                            v-bind:data-loopa="(hash || '').slice(0, -6)"
                            v-bind:data-poopa="(hash || '').slice(-6)"/>
                        <template v-else>{{ hash }}</template>
                    </ui-copy-button>
                </td>
            </tr>
            <tr v-if="bounce !== null">
                <td>Bounce</td>
                <td>
                    {{ bounce }}
                </td>
            </tr>
            <tr v-if="comment">
                <td>Message</td>
                <td>{{comment || 'empty'}}</td>
            </tr>
            <tr v-if="op">
                <td>Operation</td>
                <td>
                    {{ op }}
                    <span v-if="getOpcodeLabel" class="muted">– {{ getOpcodeLabel }}</span>
                </td>
            </tr>
            <tr v-if="createdAt">
                <td>Created Time</td>
                <td>{{ formatTimestamp(createdAt) }}</td>
            </tr>
            <tr v-if="!isMobile && decodedBody">
                <td>Decoded body</td>
                <td>
                    <SourceJson
                        v-bind:rawBody="rawBody"
                        v-bind:transactionDescription="decodedBody"
                    />
                </td>
            </tr>
        </table>
        <div v-if="isMobile && decodedBody" class="tx-decoded-body">
            <div class="tx-decoded-body__title">
                <span>Decoded body</span>
            </div>
            <div class="tx-decoded-body__json">
                <SourceJson
                    v-bind:rawBody="rawBody"
                    v-bind:transactionDescription="decodedBody"
                />
            </div>
        </div>
    </section>
</template>

<script>
import { formatTimestamp } from '~/helpers.js';
// eslint-disable-next-line import/extensions
import opCodesDictionary from '../../../json/traceLabels.json';
import SourceJson from './Transaction/Json/SourceJson.vue';

export default {
    props: {
        source: String,
        destination: String,
        value: String,
        fwdFee: String,
        ihrFee: String,
        createdLt: String,
        hash: String,
        comment: String,
        op: String,
        createdAt: Number,
        rawBody: String,
        decodedBody: Object,
        bounce: Boolean,
    },

    computed: {
        getOpcodeLabel() {
            return opCodesDictionary[this.op] || null;
        },
    },

    methods: {
        formatTimestamp,
    },

    components: {
        SourceJson,
    },
};
</script>

<style lang="scss">
// On mobile the hash is truncated in the middle to keep it on one line with the copy icon;
// max-width: 0 holds the value column to the screen width instead of widening the table:
.tx-msg-table--mobile td:last-child {
    max-width: 0;
}
.tx-msg-hash {
    display: inline-flex;
    align-items: center;
    max-width: 100%;

    .ui-copy-button__icon {
        flex-shrink: 0;
    }
}
.tx-decoded-body__title {
    white-space: nowrap;
}
@media all and (max-width: 900px) {
    .tx-decoded-body {
        display: flex;
        flex-direction: column;

        &__title {
            padding: 6px 10px 6px 0;
            font-weight: 500;
            white-space: nowrap;
        }

        &__json {
            padding: 6px 0!important;
        }
    }
}
</style>
